import React from 'react';
import { Form, Field, FieldArray, useFormikContext } from 'formik';
import {  Button, Grid, Divider, Link, Typography, LinearProgress, Box } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { referenceDataSchema, referenceDataValueSchema } from '../ReferenceDataDetailContext';
import * as yup from 'yup';
import { DeleteIconButton } from 'components';
import { useHistory, useLocation } from 'react-router-dom';
import { FaSortAlphaDown } from 'react-icons/fa';


interface IProps {
    isSorting: boolean
    sortBy: (sort: 'key' | 'description') => Promise<void>
}

let ReferenceDataForm = (props: IProps) => {
    let history = useHistory();
    let location = useLocation();

    let isNew = location.pathname.includes('/addnew');

    type ReferenceData = yup.InferType<typeof referenceDataSchema>;

    let form = useFormikContext<ReferenceData>();


    return (
        <Box maxWidth="md">
            <Form>
                {isNew === false && <Typography variant="h4">{form.values.key}</Typography>}
                {isNew === true &&
                    <Field
                        component={TextField}
                        name="key"
                        fullWidth
                        margin="normal"
                        label="Key"
                    />
                }
                <Divider style={{ marginTop: 16, marginBottom: 16 }} />
                <FieldArray name="values">
                    {helpers =>
                        <>
                            <Grid container spacing={2}>
                                {form.values.values.length > 1 &&
                                    <>
                                        <Grid item xs={3}>
                                            <Link
                                                component="button"
                                                disabled={props.isSorting}
                                                onClick={() => props.sortBy('key')}
                                            >
                                                <FaSortAlphaDown />&nbsp;Sort by key
                                            </Link>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Link
                                                component="button"
                                                disabled={props.isSorting}
                                                type="button"
                                                onClick={() => props.sortBy('description')}
                                            >
                                                <FaSortAlphaDown />&nbsp;Sort by description
                                            </Link>
                                        </Grid>
                                    </>
                                }
                                <Grid item xs />
                                <Grid item>
                                    <Link
                                        component="button"
                                        disabled={props.isSorting}
                                        type="button"
                                        onClick={() => {
                                            let maxSort = form.values.values.length === 0 ? 0 : Math.max(...form.values.values.map(x => x.sortOrder));

                                            helpers.insert(0, {
                                                ...referenceDataValueSchema.getDefault(),
                                                sortOrder: maxSort + 1
                                            })
                                        }}
                                    >
                                        New value
                                    </Link>
                                </Grid>
                            </Grid>
                            {props.isSorting && <LinearProgress style={{ marginTop: 16, marginBottom: 16 }} />}
                            {form.values.values
                                .map((value, index) =>
                                    <React.Fragment key={index}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={3}>
                                                {value.isNew === true &&
                                                    <Field
                                                        component={TextField}
                                                        name={`values[${index}].key`}
                                                        label="Key"
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                }
                                                {!value.isNew && <Typography>{value.key}</Typography>}
                                            </Grid>
                                            <Grid item xs>
                                                <Field
                                                    component={TextField}
                                                    name={`values[${index}].description`}
                                                    label="Description"
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Field
                                                    component={TextField}
                                                    name={`values[${index}].sortOrder`}
                                                    label="Sort order"
                                                    type="number"
                                                    margin="dense"
                                                    variant="outlined"
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item>
                                                <DeleteIconButton onClick={() => helpers.remove(index)} />
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                )}
                        </>
                    }
                </FieldArray>

                <Grid item container>
                    <Grid item xs/>
                    <Grid item>
                        <Button
                            color="secondary"
                            variant="outlined"
                            type="button"
                            onClick={() => history.replace('/admin/referencedata')}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            type="submit"
                            color="secondary"
                            variant="contained"
                        >
                            Save
                        </Button>
                    </Grid>


                </Grid>

            </Form >
        </Box>
    )
}

export default ReferenceDataForm;